import styled from "styled-components";

export const FooterContainer = styled.footer`
  background-color: ${(props) => props.theme.colors.card};

  padding: 40px 0 20px;
`;

export const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FooterMain = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 30px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const LogoSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    margin-bottom: 30px;
  }
`;

export const Logo = styled.p`
  font-size: 1rem;

  color: ${(props) => props.theme.colors.primary};
`;

export const Tagline = styled.p`
  font-size: 1rem;
  color: ${(props) => props.theme.colors.secondary};
  margin: 0;
`;

export const NavSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: center;
    width: 100%;
  }
`;

export const NavLinks = styled.nav`
  display: flex;
  gap: 30px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
    gap: 20px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 15px;
  }
`;

export const NavLink = styled.a`
  color: ${(props) => props.theme.colors.secondary};
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const Copyright = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.secondary};
  padding-top: 20px;
  width: 100%;
  text-align: center;
  color: ${(props) => props.theme.colors.secondary};
  font-size: 0.9rem;

  p {
    display: inline-block;
    font-size: inherit;
    &:first-of-type {
      margin-right: 5px;
    }
    @media (max-width: 768px) {
      &:first-of-type {
        margin-right: 0;
      }
      display: block;
    }
  }
`;
